import React from 'react';
import { Establishment } from '../EstablishmentTypes';
import { EnhancedEstablishmentCell, DateCell, NafCodeCell, SizeCell, SiegeCell } from './TableCells';
import { useTableUtils } from './useTableUtils';

interface OutOfSectorEstablishmentRowProps {
  establishment: Establishment;
  utils: ReturnType<typeof useTableUtils>;
}

export const OutOfSectorEstablishmentRow: React.FC<OutOfSectorEstablishmentRowProps> = ({ 
  establishment, 
  utils 
}) => (
  <>
    <EnhancedEstablishmentCell 
      establishment={establishment} 
      copyToClipboard={utils.copyToClipboard} 
      openGoogleSearch={utils.openGoogleSearch}
    />
    <DateCell date={establishment.creationDate} />
    <NafCodeCell nafCode={establishment.nafCode} getNafCodeLabel={utils.getNafCodeLabel} />
    <SizeCell trancheEffectifs={establishment.trancheEffectifs} categorieEntreprise={establishment.categorieEntreprise} />
    <SiegeCell 
      siege={establishment.siege} 
      getNafCodeLabel={utils.getNafCodeLabel} 
      copyToClipboard={utils.copyToClipboard} 
    />
  </>
); 